

import React, { useEffect, useState } from 'react'
import EyeIcon from "../../common/assests/eyegreen.png";
import Adminimg from "../../common/assests/adminimg.png";
import CrossIcon from "../../common/assests/croosicon.png";
import DeletIcon from "../../common/assests/deleticon.png";
import SearchItem from "../../common/assests/search.svg";
import SearchIcon from "@mui/icons-material/Search";
import { Box, IconButton, Paper, Pagination, PaginationItem, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery, Dialog, DialogContent, DialogTitle, Modal, TextField, InputAdornment, Button, } from '@mui/material';
import Paginations from '../../common/pagination/Paginations';
import StarIcon from '@mui/icons-material/Star';

import TestingImg from "../../common/assests/gridimg3.png";
import Clock from "../../common/assests/clock.svg";
import { acceptProductApi, allPendingProductsApi, rejectProductApi } from '../../api';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Loader from '../../common/loader/Loader';
import UserImg from "../../common/assests/sampleuser.svg";
import { toast } from 'react-toastify';
import configuration from '../../config/Config';


const NewAddedProduct = () => {

  const token = useSelector((state) => state?.user?.user?.token);
  const { id } = useParams();
  const [selectedRow, setSelectedRow] = useState(null);
  const isSmallScreen = useMediaQuery("(max-width:480px)");
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const handleRejectModalOpen = () => setRejectModalOpen(true);
  const handleRejectModalClose = () => setRejectModalOpen(false);

  const [pendingProductData, setPendingProductData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [change, setChange] = useState(false);
  const [myTimout, setMyTimeOut] = useState()
  const [reason, setReason] = useState("");
  const [open, setOpen] = useState(false);

  const [timeoutId, setTimeoutId] = useState(null);

  const handleNewProduct = async () => {
    try {
      setLoading(true);
      const response = await allPendingProductsApi({ token, currentPage, searchQuery, id });
      setPendingProductData(response?.products || []);
      // console.log("pedning products", response);
      setCurrentPage(response?.currentPage)
      setTotalPages(response?.totalPages)
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const handleRejectProduct = async (id) => {
    if (!reason) {
      toast.warning("Reason Required")
      return
    }
    const isConfirmed = window.confirm("Are you sure, you want to Reject this Product?");
    if (!isConfirmed) {
      return;
    }
    try {
      const status = "rejected"
      const response = await rejectProductApi({ token, id, status, reject_reason: reason });
      setReason("");
      setChange(!change)
      toast.success(response.message)
      setOpen(false);
      // setRejectModalOpen(false);
    } catch (error) {
      toast.error(error.message)
      console.log("error", error);
    }
  }

  const handleAcceptProduct = async (id) => {
    const isConfirmed = window.confirm("Are you sure, you want to Accept this Product?");
    if (!isConfirmed) {
      return;
    }
    try {
      const status = "active"
      const response = await acceptProductApi({ token, id, status });
      setChange(!change)
      toast.success(response.message)
    } catch (error) {
      toast.error(error.message)
      console.log("error", error);
    }
  }

  useEffect(() => {
    handleNewProduct()
  }, [currentPage, change])

  // useEffect(() => {
  //   if(searchQuery.trim()!=""){
  //   clearTimeout(myTimout);
  //   setMyTimeOut(setTimeout(handleNewProduct, 500));
  //   }
  // }, [searchQuery]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      handleNewProduct();
    } else {
      clearTimeout(myTimout);
      const timeout = setTimeout(() => handleNewProduct(), 500);
      setMyTimeOut(timeout);
    }
  }, [searchQuery]);


  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };

  const handleClickOpen = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const tableHeaders = [
    "Image",
    "Name",
    "Category",
    "Price",
    "Discounted Price",
    "Date of Submitted",
    "Status",
    "Action"
  ];


  return (
    <div>

      {loading ? (
        <Loader variant="table" />
      ) : (

        <Box sx={{ marginTop: "40px", marginBottom: "30px" }}>
          <TableContainer
            component={Paper}
            sx={{
              padding: "26px", borderRadius: "24px",
              overflowY: "auto",
              overflowX: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
                gap: { xs: "15px" },
                // width:'100vw'
              }}
            >
              <Typography
                sx={{ fontSize: { xs: '16px', sm: '20px' }, fontWeight: "600", color: "#362B24" }}
              >
                Product List
              </Typography>
              <TextField

                placeholder="Search by name"
                value={searchQuery}
                onChange={(e) => {
                  if (e.target.value.trim() !== "" || e.target.value === "") {
                    setSearchQuery(e.target.value);
                  }
                }}
                sx={{
                  width: { xs: '60%', sm: 200 },
                  height: { xs: 45, sm: 46 },
                  flexShrink: 0,

                  borderRadius: "33px",
                  background: "#EBEBEB",
                  "& .MuiOutlinedInput-input": {
                    height: "30%",
                  },
                  border: "none",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "33px",
                    height: "100%",
                    paddingRight: "10px",
                    outline: "none",
                    border: "none",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={SearchItem}
                        sx={{ color: "#000", opacity: "0.35" }}
                      />
                    </InputAdornment>
                  ),
                  style: { height: "100%" },
                }}
              />
            </Box>

            <Table sx={{ minWidth: 650 }} aria-label="custom table">
              <TableHead>
                <TableRow>
                  {tableHeaders.map((header, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        color: "#362B24",
                        fontWeight: "600",
                        fontFamily: "Heebo",
                        fontSize: "16px",
                      }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {pendingProductData.length > 0 ? (
                  pendingProductData.map((row) => (
                    <TableRow
                      key={row._id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={
                              row?.photos && row.photos.length > 0
                                ? `${configuration.cdnFront}/${row.photos[0].url}`
                                : UserImg
                            }
                            alt={"product-img"}
                            style={{
                              height: "45px",
                              width: "45px",
                              marginRight: "8px",
                              borderRadius: "50%",
                            }}
                          />

                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>
                          <Typography >{row?.title || "-"}</Typography>
                        </Box>
                      </TableCell>
                      <TableCell>{row?.categoryId?.name || "-"}</TableCell>
                      <TableCell>{`$${row?.price || "-"}`}</TableCell>
                      <TableCell>{`$${row?.discountedProce || "-"}`}</TableCell>
                      <TableCell>{row?.updated_at ? new Date(row?.updated_at).toLocaleDateString() : "-"}</TableCell>
                      <TableCell>{row?.status || "-"}</TableCell>
                      <TableCell sx={{
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
                        flexWrap: { xs: 'wrap', lg: 'nowrap' },
                      }}>
                        <IconButton onClick={() => handleClickOpen(row)}>
                          <img
                            src={EyeIcon}
                            alt="viewicon"
                            style={{
                              height: isSmallScreen ? "35px" : "45px",
                              width: isSmallScreen ? "35px" : "45px",
                            }}
                          />
                        </IconButton>


                        <Button
                          onClick={() => handleAcceptProduct(row?._id)}
                          sx={{
                            width: "94px",
                            height: "44px",
                            borderRadius: "15px",
                            backgroundColor: "#065F46",
                            color: "#FFF",
                            textTransform: "none",
                            "&:hover": {
                              backgroundColor: "#065F46",
                            },
                            flexShrink: 0,
                          }}
                        >
                          Accept
                        </Button>
                        <Button
                          onClick={() => {
                            setSelectedRow(row); 
                            handleRejectModalOpen()
                          }}
                          sx={{
                            width: "94px",
                            height: "44px",
                            borderRadius: "15px",
                            backgroundColor: "#EA001B",
                            color: "#FFF",
                            textTransform: "none",
                            "&:hover": {
                              backgroundColor: "#EA001B",
                            },
                            flexShrink: 0,
                          }}
                        >
                          Reject
                        </Button>

                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow align="center">
                    <TableCell colSpan={tableHeaders.length}>
                      <Typography align="center">No Data Found</Typography>
                    </TableCell>
                  </TableRow>
                )}

              </TableBody>
            </Table>



            <Paginations
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              disabled={loading}
            />



          </TableContainer>
        </Box>
      )}




      <Modal
        open={open}
        onClose={handleClose}
      >
        <Box
          sx={{
            // maxWidth: '874px',
            maxWidth: '630px',
            width: '90%',
            maxHeight: '80vh',
            bgcolor: '#F5F5F5',
            borderRadius: '24px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            boxShadow: 24,
            p: '20px',
            overflowY: 'auto',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography sx={{ fontSize: '20px', fontWeight: '700' }}>Product Details</Typography>
            <IconButton onClick={handleClose}>
              <img
                src={CrossIcon}
                alt="img"
                style={{ width: '20px', height: '20px', cursor: 'pointer' }}
              />
            </IconButton>
          </Box>

          {selectedRow && (
            <Box sx={{ marginTop: "20px" }}>
              <img
                src={
                  selectedRow?.photos && selectedRow.photos.length > 0
                    ? `${configuration.cdnFront}/${selectedRow.photos[0].url}`
                    : UserImg
                }
                alt={"product-img"}
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '231px',
                  borderRadius: '24px',
                  marginBottom: '20px',
                }}
              />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(100px, 0fr))",
                  gap: "5px"
                }}
              >
                {selectedRow?.photos?.map((image) => (
                  <Box
                    key={image?._id}
                    sx={{
                      width: "77px",
                      height: "79px",
                      flexShrink: 0,
                      borderRadius: "16px",
                      boxShadow: "3px 2px 20px 0px rgba(0, 0, 0, 0.04)",
                      overflow: "hidden",
                      "@media (max-width: 767px)": {
                        width: "100%",
                        height: "auto",
                      },
                    }}
                  >
                    <img
                      src={
                        image?.url
                          ? `${configuration.cdnFront}/${image.url}`
                          : UserImg
                      }
                      alt="img"
                      style={{
                        width: "100%",

                        height: "100%",
                        maxHeight: "80px",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                ))}
              </Box>


              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(120px, 0fr))",
                  gap: 3,
                  marginTop: '25px'
                }}

              >
                <Box>
                  <Typography
                    sx={{ fontWeight: "400", fontSize: '13px', opacity: "0.6", color: "#362B24" }}
                  >
                    Product Name
                  </Typography>
                  <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                    <strong>{selectedRow?.title || "-"}</strong>
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{ fontWeight: "400", fontSize: '13px', opacity: "0.6", color: "#362B24" }}
                  >
                    Product Category
                  </Typography>
                  <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                    <strong>{selectedRow?.categoryId?.name || "-"}</strong>
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    sx={{
                      fontWeight: "400",
                      opacity: "0.6",
                      color: "#362B24",
                      fontSize: "15px",
                    }}
                  >
                    Price
                  </Typography>
                  <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                    <strong>{`$${selectedRow?.price || "-"}`}</strong>
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{ fontWeight: "400", fontSize: '13px', opacity: "0.6", color: "#362B24" }}
                  >
                    Discount Price
                  </Typography>
                  <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                    <strong>{`$${selectedRow?.discountedProce || "-"}`}</strong>
                  </Typography>
                </Box>

              </Box>


              <Box>
                <Typography
                  sx={{ fontWeight: "600", fontSize: '16px', color: "#362B24", marginTop: '20px' }}
                >
                  Description
                </Typography>
                <Typography sx={{ fontSize: "13px", opacity: "0.5", color: "#362B24", fontWeight: '400', lineHeight: '24px' }}>
                  {selectedRow?.description || "N/A"}
                </Typography>
              </Box>


              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                  mt: 3,
                  mb: 1,
                  flexWrap: 'wrap'

                }}
              >
                <Button
                  onClick={() => handleAcceptProduct(selectedRow?._id)}
                  sx={{
                    width: "180px",
                    height: "50px",
                    borderRadius: "15px",
                    backgroundColor: "#065F46",
                    color: "#FFF",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#065F46",
                    },
                    flexShrink: 0,
                  }}
                >
                  Accept
                </Button>
                <Button
                  onClick={() => { handleRejectModalOpen() }}
                  sx={{
                    width: "180px",
                    height: "50px",
                    borderRadius: "15px",
                    backgroundColor: "#EA001B",
                    color: "#FFF",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#EA001B",
                    },
                    flexShrink: 0,
                  }}
                >
                  Reject
                </Button>
              </Box>

            </Box>
          )}
        </Box>
      </Modal>




      <Modal
        open={rejectModalOpen}
        onClose={handleRejectModalClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            maxWidth: '538px',
            width: '90%',
            height: '418px',
            borderRadius: '32px',
            backgroundColor: '#FFF',
            display: 'flex',
            flexDirection: 'column',
            p: 3,
            mx: 'auto',
            my: 3,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 2,
            }}
          >
            <Typography
              sx={{
                color: '#362B24',
                fontSize: '20px',
                fontWeight: '700',
              }}
            >
              Reason for Rejection
            </Typography>

            <IconButton onClick={handleRejectModalClose}>
              <img
                src={CrossIcon}
                alt="Close"
                style={{ width: '20px', height: '20px', cursor: 'pointer' }}
              />
            </IconButton>
          </Box>

          <Typography sx={{
            color: '#362B24',
            marginTop: '15px',
            fontSize: '13px',
            fontWeight: '600',
          }}>
            Type your Reason
          </Typography>
          <textarea
            placeholder="Type here"
            onChange={(e) => {
              if (e.target.value.trim() !== "" || e.target.value === "") {
                setReason(e.target.value)
              }
            }
            }
            style={{
              maxWidth: '470px',
              width: '100%',
              height: '202px',
              borderRadius: '18px',
              border: '1.4px solid #362B24',
              outline: 'none',
              backgroundColor: '#FFF',
              padding: '16px',
              fontSize: '16px',
              resize: 'none',
              marginTop: '15px'

            }}
          />

          <Box sx={{
            display: 'flex',
            justifyContent: 'center', mt: 3
          }}>
            <Button
              onClick={() => {
                handleRejectProduct(selectedRow?._id)
                handleRejectModalClose();
              }}
              sx={{
                width: "196px",
                height: "50px",
                borderRadius: "15px",
                backgroundColor: "#EA001B",
                color: "#FFF",
                textTransform: "none",

                "&:hover": {
                  backgroundColor: "#EA001B",
                },
                flexShrink: 0,
              }}

            >
              Reject
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  )
}

export default NewAddedProduct